import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { clearToken } from '../../helpers/utility';
import actions from './actions';
import authActionCompany from '../../redux/company/actions';
import { handleError } from '../../errorHandler';

import {
         logintoSQL,
         logintoSQLSuccessLoadUser,
       } from '../../containers/Page/signin_api';


export function* handleLoginRequest(action) {
  const { email, password } = action.payload;
  try {
    const loginResult = yield call(logintoSQL, email, password);
    if (loginResult && loginResult.code === 200) {
      const resultUser = yield call(logintoSQLSuccessLoadUser, loginResult.JWT_TOKEN, email);
      if (resultUser && resultUser.code === 200) {
          yield put({
            type: actions.LOGIN_SUCCESS,
            token: loginResult.JWT_TOKEN,
            profile: resultUser.user,
          });
          action.resolve();
      } else {
        yield put({
          type: actions.LOGOUT,
        });
        action.reject();
      }
    // yield call(logintoSQLSuccessLoadWorkforce, payload.loginResult);
    } else {
      yield put({ type: actions.LOGIN_ERROR });
      action.reject();
    }
  } catch (e) {
    handleError(`Catch Sage: ${e}`);
    yield put({ type: actions.LOGIN_ERROR });
  }
}

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', handleLoginRequest);
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    localStorage.setItem('userprofile', payload.profile);
    localStorage.setItem('id_token', payload.token);

    const data = {
      token: payload.token,
      profile: payload.profile,
    };
    yield put({
      type: authActionCompany.LOAD_COMPANY,
      payload: data,
    });
//    yield put(push('/dashboard'));
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () {
    yield handleError('Login error');
  });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    clearToken();
    yield put(push('/'));
  });
}
export default function* rootSaga() {
  yield all([
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/auth/saga.js